export const realProductImages: Partial<
  Record<string, string>
> = {
  cappuccino: "/products/real/cappuccino.webp",
  raf: "/products/real/raf.webp",

  bumble: "/products/real/bumble.webp",
  "iced-latte": "/products/real/iced-latte.webp",
  lemonade: "/products/real/lemonade.webp",

  hotdog: "/products/real/hotdog.webp",
  corndog: "/products/real/corndog.webp",
  fries: "/products/real/fries.webp",
  nuggets: "/products/real/nuggets.webp",
  "cheese-sticks": "/products/real/cheese-sticks.webp",
};

// COFFEETRACK_MISSING_PRODUCT_PHOTOS_V318
//
// Temporary list for production readiness.
// These products still use their catalog SVG fallback.
// Remove IDs from here only after the corresponding
// /public/products/real/<id>.webp has been added and mapped.
//
export const missingRealProductImageIds = [
  "latte",
  "americano",
  "cocoa",
  "tea",
  "smoothie",
  "juice-bowl",
  "frenchdog",
  "shrimp",
] as const;

export function hasRealProductImage(
  productId: string,
) {
  return Boolean(
    realProductImages[productId],
  );
}
